import api from '@/utils/api';

/**
 * Update user
 * @param {string} id user id
 * @param {object} userRoleData - The user data
 * @returns {Promise}
 */
const updateUserRoleApi = (id, userRoleData) =>
  api.patch(`/user-role/${id}`, userRoleData);

export default updateUserRoleApi;
